import { render, staticRenderFns } from "./approvalpage.vue?vue&type=template&id=6e17dc09&scoped=true"
import script from "./approvalpage.vue?vue&type=script&lang=js"
export * from "./approvalpage.vue?vue&type=script&lang=js"
import style0 from "./approvalpage.vue?vue&type=style&index=0&id=6e17dc09&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e17dc09",
  null
  
)

export default component.exports